// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.ds.DataSourceValueBinary
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { BinaryTuple } from "abweb/dto/ds/BinaryTuple";
import { DataSourceBaseValue } from "abweb/dto/ds/DataSourceBaseValue";
import { DataFieldTypeEnum } from "abweb/dto/generated/ds/DataFieldTypeEnum";
import { DataSourceSaveAction } from "abweb/dto/generated/ds/DataSourceSaveAction";
import { DataSourceState } from "abweb/dto/generated/ds/DataSourceState";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class DataSourceValueBinaryBase extends DataSourceBaseValue {
  /** Do NOT invoke directly, instead use strongly typed createDataSourceValueBinaryBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadd.DataSourceValueBinary";
  }
  initFromJson(json, deserializeContext) {
    this.initDataSourceValueBinary(json.attributeValues != null ? json.attributeValues : null, json.clientTag != null ? json.clientTag : null, json.dataSourceSaveAction != null ? DataSourceSaveAction.fromJson(json.dataSourceSaveAction) : null, json.editableOverwrite != null ? json.editableOverwrite : null, json.id != null ? json.id : null, json.state != null ? DataSourceState.fromJson(json.state) : null, json.baselineRefID != null ? json.baselineRefID : null, json.fieldTypeOverwrite != null ? DataFieldTypeEnum.fromJson(json.fieldTypeOverwrite) : null, json.refID != null ? json.refID : null, TSOGUtils.decodeObject(json.baselineRef, BinaryTuple, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "baselineRef")), TSOGUtils.decodeObject(json.currentValue, BinaryTuple, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "currentValue")), TSOGUtils.decodeObject(json.valueRef, BinaryTuple, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "valueRef")));
  }
  initDataSourceValueBinary(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state, baselineRefID, fieldTypeOverwrite, refID, baselineRef, currentValue, valueRef) {
    this.initDataSourceBaseValue(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state, baselineRefID, fieldTypeOverwrite, refID);
    this._baselineRef = baselineRef;
    this._currentValue = currentValue;
    this._valueRef = valueRef;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    if (this._baselineRef != null) {
      retVal["baselineRef"] = TSOGUtils.toTSOGNativeObject(this._baselineRef, serializeContext);
    }
    if (this._currentValue != null) {
      retVal["currentValue"] = TSOGUtils.toTSOGNativeObject(this._currentValue, serializeContext);
    }
    retVal["valueRef"] = TSOGUtils.toTSOGNativeObject(this._valueRef, serializeContext);
    return retVal;
  }
  get baselineRef() {
    return this._baselineRef;
  }
  set baselineRef(value) {
    this._baselineRef = value;
  }
  get currentValue() {
    return this._currentValue;
  }
  set currentValue(value) {
    this._currentValue = value;
  }
  get valueRef() {
    return this._valueRef;
  }
  set valueRef(value) {
    this._valueRef = value;
  }
}
//# sourceMappingURL=DataSourceValueBinaryBase.js.map
